import { useTheme } from '@features/theme';
import { Theme, ThemePanel } from '@radix-ui/themes';
import { ENV } from '@services';
import { AppRouter } from './router/components/AppRouter';

export function App() {
    const { theme } = useTheme();

    return (
        <Theme appearance={theme} accentColor='blue'>
            {/* <ToastProvider> */}

            <AppRouter />
            {/* </ToastProvider> */}
            {ENV.isDevelopment() && <ThemePanel defaultOpen={false} />}
        </Theme>
    );
}

export default App;
